import loadable from '@loadable/component';
export const TemplatePage=loadable(() => import('./Template'));
